import React from 'react';
import { get } from 'lodash';
import { sortCodeRegEx } from '../config';

export const splitAccountDetails = (accountDetails) => ({
	accountNumber: accountDetails.slice(6),
	sortCode: accountDetails.slice(0, 6).replace(sortCodeRegEx, '$1-'),
});
export const formatIFTAccountForTable = (name, number) => (
	<div>
		<div>
			<strong>{name}</strong>
		</div>
		<small className="u-white-space-nowrap">{number}</small>
	</div>
);

export const formatAccountForTable = (
	batchName,
	{
		account_number: accountNumber = '',
		sort_code: sortCode = '',
		name: accountName = '',
		account_holder: account_holder = '',
	} = {}
) => {
	if (batchName) {
		return (
			<div>
				<strong>{batchName}</strong>
			</div>
		);
	}
	if (accountNumber.length === 16) {
		return (
			<div>
				{accountName && (
					<div>
						<strong>{accountName}</strong>
					</div>
				)}
				{accountNumber && <small className="u-white-space-nowrap">{`${accountNumber}`}</small>}
			</div>
		);
	}
	return (
		<div>
			{account_holder && (
				<div>
					<small>{account_holder}</small>
				</div>
			)}
			{accountName && (
				<div>
					<strong>{accountName}</strong>
				</div>
			)}
			{accountNumber && (
				<small className="u-white-space-nowrap">{`${accountNumber} | ${sortCode.replace(sortCodeRegEx, '$1-')}`}</small>
			)}
		</div>
	);
};

export const formatAccountForSort = (
	batchName,
	{ account_number: accountNumber = '', name: accountName = '' } = {}
) => {
	const sort = (batchName || accountName || accountNumber || '').trim();
	return sort;
};

export const getFormattedFromAndToAccounts = (paymentDetails, fromAccount = {}, toAccount, isBacsDebit) => {
	const batchName = get(paymentDetails, 'batch_name', null);
	return {
		fromAccountFormatted: formatAccountForTable(isBacsDebit ? batchName : null, fromAccount),
		toAccountFormatted: formatAccountForTable(isBacsDebit ? null : batchName, toAccount),
		fromSort: formatAccountForSort(isBacsDebit ? batchName : null, fromAccount),
		toSort: formatAccountForSort(isBacsDebit ? null : batchName, toAccount),
	};
};

export const formatAccountDetails = ({
	account_number: accountNumber = '',
	sort_code: sortCode = '',
	name: accountName = '',
	account_holder: account_holder = '',
}) => {
	if (accountNumber.length === 16) {
		if (accountName) {
			return `${accountName} | ${accountNumber}`;
		}
		return accountNumber;
	}
	const sortCodeRegEx = /(\d{2})(?=\d)/g;
	const formattedSortCode = sortCode.replace(sortCodeRegEx, '$1-');
	if (accountName) {
		if (account_holder) {
			return `${account_holder} | ${accountName} | ${formattedSortCode} | ${accountNumber}`;
		}
		return `${accountName} | ${formattedSortCode} | ${accountNumber}`;
	}
	return `${formattedSortCode} | ${accountNumber}`;
};

export const formatIFTAccountDetails = (name, number) => `${name} | ${number}`;
